import { render, staticRenderFns } from "./Autosuggest.vue?vue&type=template&id=3513f8ce&scoped=true&"
import script from "./Autosuggest.vue?vue&type=script&lang=js&"
export * from "./Autosuggest.vue?vue&type=script&lang=js&"
import style0 from "./Autosuggest.vue?vue&type=style&index=0&id=3513f8ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513f8ce",
  null
  
)

export default component.exports